<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑     永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2022-11-11 10:21:47
 * @LastEditTime: 2022-11-11 17:43:11
 * @Description: 重置密码
 * @FilePath: \BusinessPlatform\src\views\login\components\resetPasswordModule.vue
 -->


<template>
    <div class="resetPasswordModule">
        <dl>
            <dt class="iconfont iconanquan">
                砼享云安全中心
            </dt>
            <dd class="fomeBox">
                <div class="resetSteps">
                    <el-steps :active="completeSteps" finish-status="success" align-center>
                        <el-step title="输入账号"></el-step>
                        <el-step title="输入验证码"></el-step>
                        <el-step title="重置密码"></el-step>
                        <el-step title="完成"></el-step>
                    </el-steps>
                </div>
                <div class="resetBox">
                    <component
                        class="resetView"
                        ref="ref_resetView"
                        :is="dynamicView"
                        :view-parameter="viewParameter"
                        @nextStep="nextStep"
                        @backLogin="backLogin"
                    ></component>
                    <button class="iconfont iconjiantouzuo backButton" @click="backLogin">
                        返回登录
                    </button>
                </div>
            </dd>
        </dl>
    </div>
</template>

<script>
export default {
    name: 'reset-password-module',
    components: {},
    data() {
        return {
            completeSteps: 0,
            dynamicView: null,
            viewParameter: {},
        };
    },
    watch: {},
    created() {
        this.dynamicView = () => import('./resetPassword/accountNumber.vue');
    },
    mounted() {},
    computed: {},
    methods: {
        // 返回登录页
        backLogin() {
            this.$emit('backLogin');
        },

        // 下一步切换页面
        nextStep(data) {
            if (data.stepNo === 1) {
                this.completeSteps = data.stepNo;
                this.viewParameter = {
                    phoneNumber: data.phoneNumber,
                };
                this.dynamicView = () => import('./resetPassword/verificationCode.vue');
            } else if (data.stepNo === 2) {
                this.$emit('callPictureVerification', data);
            } else if (data.stepNo === 3) {
                this.completeSteps = 4;
                this.dynamicView = () => import('./resetPassword/completeReset.vue');
            }
        },

        // 图片验证通过
        pictureVerificationPassed(data) {
            this.completeSteps = data.stepNo;
            this.viewParameter = {
                phoneNumber: data.phoneNumber,
                verify_code: data.verification,
            };
            this.dynamicView = () => import('./resetPassword/resetPassword.vue');
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.resetPasswordModule
    height 100%
    background url('./../images/bg.png') center no-repeat
    background-size 100%
    position: relative
    display: flex
    justify-content center
    align-items center
    dl
        width 600px
        dt
            line-height: 40px
            font-size 18px
            color #0078FD
            font-weight: 500;
        .fomeBox
            height: 500px
            background: #FFFFFF;
            box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
            border-radius: 4px;
            .resetSteps
                height: 94px
                border-bottom 1px solid #F0F0F0
                padding: 20px
                >>>.el-steps
                    .el-step
                        .el-step__head
                            .el-step__icon
                                position: relative
                                &:after
                                    content ''
                                    width 32px
                                    height 32px
                                    border-radius: 50%
                                    background: rgba(175, 180, 192, 0.3)
                                    position: absolute
                                    top 50%
                                    left 50%
                                    transform: translate(-50%, -50%)
                                    z-index 1
                                .el-step__icon-inner
                                    width 24px
                                    height 24px
                                    background: #AFB4C0
                                    position: absolute
                                    z-index 2
                                    border-radius: 50%
                                    font-size: 16px
                                    color #fff
                                    line-height: 24px
                            &.is-success
                                .el-step__icon
                                    &:after
                                        background: rgba(122, 194, 61, 0.3)
                                    .el-step__icon-inner
                                        background: #7AC23D
                        .el-step__main
                            .el-step__title
                                &.is-success
                                    color #7AC23D
            .resetBox
                padding: 38px 130px 0
                .backButton
                    font-size 14px
                    color #868FA3
                    padding: 20px 0
                    border none
                    background: none
                    cursor pointer
</style>
